<template>
    <ProductMaterialMixtureCategorySelector
        :material-category-ids="product.materialCategoryIds || []"
        :mixture-category-ids="product.mixtureCategoryIds || []"
        @change="$emit('change', $event)"
    />
</template>

<script>
import ProductMaterialMixtureCategorySelector from '@/views/product/components/product-card/common/categories'

export default {
    name: 'WorkflowMaterialMixtureCategoriesSection',
    components: {
        ProductMaterialMixtureCategorySelector,
    },
    props: {
        product: { type: Object, required: true },
    },
}
</script>
